
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/traffic/information/[state]/[generalSlug]",
      function () {
        return require("private-next-pages/traffic/information/[state]/[generalSlug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/traffic/information/[state]/[generalSlug]"])
      });
    }
  